export default "__VITE_ASSET__BtcgFiCR__"